import { render, staticRenderFns } from "./DayAmount.vue?vue&type=template&id=05a0b92e&scoped=true&"
import script from "./DayAmount.vue?vue&type=script&lang=js&"
export * from "./DayAmount.vue?vue&type=script&lang=js&"
import style0 from "./DayAmount.vue?vue&type=style&index=0&id=05a0b92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0b92e",
  null
  
)

export default component.exports